import { render, staticRenderFns } from "./AdminCommission.vue?vue&type=template&id=53baf523&scoped=true"
import script from "./AdminCommission.vue?vue&type=script&lang=js"
export * from "./AdminCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53baf523",
  null
  
)

export default component.exports